var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-cell-button",style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled}},[(_vm.label)?_c('span',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),(_vm.icon)?_c('dash-icon',{staticClass:"icon",attrs:{"icon":_vm.icon,"alt":_vm.label}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }